import aa from "../AdminPortal/adminApp.module.css";
import { buildSessionAttendanceInsight } from "../../../utils/sessionAttendanceInsight";

const TONE_CLASS = {
  positive: aa.sessionAttendCard_positive,
  negative: aa.sessionAttendCard_negative,
  warning: aa.sessionAttendCard_warning,
  success: aa.sessionAttendCard_success,
  neutral: aa.sessionAttendCard_neutral,
  muted: aa.sessionAttendCard_muted,
};

const PHASE_ICON = {
  upcoming: "📋",
  live: "🏃",
  past: "✓",
};

export default function SessionSheetAttendanceCard({
  session,
  expectationSummary,
  pollStats,
  roll,
  accentColor,
  sheetOnly = false,
}) {
  const insight = buildSessionAttendanceInsight({
    session,
    expectationSummary,
    pollStats,
    roll,
    sheetOnly,
  });

  if (!insight.headline && insight.metrics.length === 0) return null;

  const toneClass = TONE_CLASS[insight.tone] || TONE_CLASS.neutral;
  const icon = sheetOnly
    ? "📊"
    : insight.showIncompleteWarning
      ? "⚠️"
      : PHASE_ICON[insight.phase] || "📊";

  const eyebrow =
    insight.eyebrow ||
    (insight.phase === "past"
      ? insight.showIncompleteWarning
        ? "Перекличка"
        : "Итог занятия"
      : insight.phase === "live"
        ? "Сейчас на занятии"
        : "Явка по опросу");

  return (
    <div className={`${aa.sessionAttendCard} ${toneClass}`}>
      <div className={aa.sessionAttendCardHead}>
        <span className={aa.sessionAttendCardIcon} aria-hidden>
          {icon}
        </span>
        <div className={aa.sessionAttendCardTitles}>
          <span className={aa.sessionAttendCardEyebrow}>{eyebrow}</span>
          {insight.headline ? (
            <p className={aa.sessionAttendCardHeadline}>{insight.headline}</p>
          ) : null}
        </div>
      </div>

      {insight.metrics.length > 0 ? (
        <div className={aa.sessionAttendCardMetrics}>
          {insight.metrics.map((m) => (
            <div key={m.key} className={aa.sessionAttendCardMetric}>
              <span
                className={`${aa.sessionAttendCardMetricVal} ${
                  aa[`sessionAttendCardMetricVal_${m.tone}`] || ""
                }`}
              >
                {m.value}
              </span>
              <span className={aa.sessionAttendCardMetricLbl}>{m.label}</span>
            </div>
          ))}
        </div>
      ) : null}

      {insight.subline ? (
        <p className={aa.sessionAttendCardSub}>{insight.subline}</p>
      ) : null}
      {insight.detail ? (
        <p className={aa.sessionAttendCardDetail}>{insight.detail}</p>
      ) : null}

      {insight.progress != null && insight.showIncompleteWarning ? (
        <div className={aa.sessionAttendCardProgress}>
          <div className={aa.sessionAttendCardProgressTrack}>
            <span
              style={{
                width: `${insight.progress}%`,
                background: accentColor || "var(--aa-accent)",
              }}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
}
